<template>
  <form-field-select
    :label="label"
    v-model="filterValue"
    placeholder="No filter"
    @change="handleInput"
    :help-text="helpText"
  >
    <option v-if="includeNoSource" :value="null">No Filter</option>
    <optgroup label="Imports">
      <option :value="MODELS.Import.class_name">All Imports</option>
      <option
        v-for="imp in imports"
        :key="imp.id"
        :value="imp.id"
      >{{ imp.label }}
      </option>
    </optgroup>

    <optgroup label="Phone Integration">
      <option :value="MODELS.IntegrationPhoneNumber.class_name">All Phone Integrations</option>
      <option
        v-for="phone in phoneNumbers"
        :key="phone.id"
        :value="phone.id"
      >{{ phone.label }}
      </option>
    </optgroup>

    <optgroup label="Launch Control Integration">
      <option
        v-for="lc in launchControl"
        :key="lc.id"
        :value="lc.id"
      >{{ lc.label }}
      </option>
    </optgroup>

    <optgroup label="Webhooks">
      <option :value="MODELS.Webhook.class_name">All Webhooks</option>
      <option
        v-for="webhook in webhooks"
        :key="webhook.id"
        :value="webhook.id"
      >{{ webhook.label }}
      </option>
    </optgroup>

    <optgroup label="Call Scripts">
      <option :value="MODELS.CallScript.class_name">All Call Scripts</option>
      <option
        v-for="callScript in leadCallScripts"
        :key="callScript.id"
        :value="callScript.id"
      >{{ callScript.label }}
      </option>
    </optgroup>
  </form-field-select>
</template>

<script>
import api from "../../api";
import { MODELS } from "../../services/models";
import {ENUMS} from "../../services/enums";

export default {
  name: "FilterSourcesSelector",
  props: {
    label: {
      type: String,
      default: "Source"
    },
    storeModule: {
      type: String,
      required: true
    },
    filterName: {
      type: String,
      required: true
    },
    includeNoSource: {
      type: Boolean,
      default: false,
    },
    helpText: String,
  },
  model: {
    prop: 'value',
    event: 'updateValue'
  },
  data() {
    return {
      imports: [],
      webhooks: [],
      launchControl: [],
    }
  },
  created() {
    this.handleInput();
    this.getFilters();
  },
  computed: {
    filterValue: {
      get() {
        const source = this.$store.state[this.storeModule].filters[this.filterName].sources;
        const sourceId = this.$store.state[this.storeModule].filters[this.filterName].sourceId;

        return (!sourceId) ? source : `${source}-${sourceId}`;
      },
      set(value) {
        const model = value.split("-");

        this.$store.commit(this.storeModule + "/setOneFilter", [
          this.filterName,
          "sources",
          model[0] ?? null
        ]);

        this.$store.commit(this.storeModule + "/setOneFilter", [
          this.filterName,
          "sourceId",
          model[1] ?? null
        ]);
      }
    },
    phoneNumbers() {
      return this.$store.getters.integrationPhoneNumbers.map(phone => {
        return {
          id: `${MODELS.IntegrationPhoneNumber.class_name}-${phone.id}`,
          label: `${phone.label} - ${phone.number}`
        }
      });
    },
    leadCallScripts() {
      return this.$store.getters.callScripts.filter(callScript => {
          return callScript.type !== ENUMS.CallScriptTypeEnum.Contact.value
        })
        .map(callScript => {
          return {
            id: `${MODELS.CallScript.class_name}-${callScript.id}`,
            label: callScript.name
          }
        });
    },
    text() {
      if (!this.filterValue) return null;

      const model = this.filterValue.split("-");

      if (!model) return null;

      if (model[0] === MODELS.Import.class_name) return "Source: Imports";
      if (model[0] === MODELS.IntegrationPhoneNumber.class_name) return "Source: Phone Integration";
      if (model[0] === ENUMS.IntegrationTypeEnum.LaunchControl.value) return "Source: Launch Control Integration";
      if (model[0] === MODELS.Webhook.class_name) return "Source: Webhooks";
      if (model[0] === MODELS.CallScript.class_name) return "Source: Call Scripts";
    },
  },
  methods: {
    getFilters() {
      api.leadsTable.getSourceFilter()
        .then((res) => {
          this.imports = res.data.imports.map(imp => {
            return {
              id: `${imp.class_name}-${imp.id}`,
              label: imp.label
            }
          });

          this.webhooks = res.data.webhooks.map(webhook => {
            return {
              id: `${webhook.class_name}-${webhook.id}`,
              label: webhook.label
            }
          });

          this.launchControl = res.data.launchControl.map(lc => {
            return {
              id: `${lc.class_name}-${lc.id}`,
              label: lc.label
            }
          });
        });
    },
    handleInput() {
      this.$emit("input", this.text);
      this.$emit("change", this.text);
      this.$emit("selected", this.text);
      this.$emit('updateValue', this.text);
    },
  }
}
</script>

<style scoped lang="scss">

</style>
